import GLightbox from 'glightbox';
const materialsLightBox = () => {

    const product__materials = GLightbox({
        selector: '.materials__open'
    });

};

materialsLightBox()
